import React from "react";
import { Link } from "react-router-dom";
import { Heart, LogIn } from "lucide-react";
import Navbar from "./Navbar";
import { useAuth } from "../context/AuthContext";

/**
 * Standard top-of-page header for the whole site.
 *
 * - Logged-in users → full Navbar (Descobrir / Actividade / Mensagens / Diário …)
 * - Anonymous users → minimal bar with Soulmatch logo + "Entrar" CTA, so legal /
 *   knowledge pages (Termos, Reembolsos, Privacidade, Artigos) keep an obvious
 *   way back to the marketing home and login.
 *
 * Drop this at the top of any page and you get the right thing automatically.
 */
const SiteHeader = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navbar />;

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-2xl bg-[#0C0E12]/70 border-b border-white/10"
      data-testid="site-header-public"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="public-nav-logo">
          <Heart className="w-5 h-5 text-[#C5A880]" />
          <span className="font-display text-xl tracking-tight">Soulmatch</span>
        </Link>
        <div className="flex items-center gap-2">
          <Link
            to="/login"
            className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm text-[#DCD7D2] hover:text-[#C5A880] hover:bg-white/5 transition-colors"
            data-testid="public-nav-login"
          >
            <LogIn className="w-3.5 h-3.5" /> Entrar
          </Link>
          <Link
            to="/register"
            className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-[#C5A880]/10 border border-[#C5A880]/40 text-[#C5A880] hover:bg-[#C5A880]/20 text-sm transition-colors"
            data-testid="public-nav-register"
          >
            Criar conta
          </Link>
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;
